import React from 'react';
import PropTypes from 'prop-types';
import NotFoundState from '.';
import NotFoundSearch from './NotFoundSearch';

const NOT_FOUND_STATUS_CODE = '404';

function PageNotFound({
    title, description, backHomeLabel, testId, backHomeTestId,
}) {
    return (
        <NotFoundState
            statusCode={NOT_FOUND_STATUS_CODE}
            title={title}
            description={description}
            search={<NotFoundSearch />}
            backHomeLabel={backHomeLabel}
            testId={testId}
            backHomeTestId={backHomeTestId}
        />
    );
}

PageNotFound.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    backHomeLabel: PropTypes.string.isRequired,
    testId: PropTypes.string.isRequired,
    backHomeTestId: PropTypes.string.isRequired,
};

export default PageNotFound;
